import { SearchAchReturnItemDto } from '@treasury/api/channel';
import { format } from 'date-fns';
import { DomainEntity } from '../shared';

const defaultSearchAchReturnItemDto: SearchAchReturnItemDto = {
    achReturnTransactionUniqueId: '',
    amount: 0,
    effectiveDate: '',
    receivedDate: '',
};

export class AchReturnActivity extends DomainEntity<SearchAchReturnItemDto> {
    constructor(protected dto = defaultSearchAchReturnItemDto) {
        super(dto);
    }

    public createDefault(): this {
        return new AchReturnActivity() as this;
    }

    public get achReturnTransactionUniqueId() {
        return this.dto.achReturnTransactionUniqueId;
    }

    public get achCompanyName() {
        return this.dto.achCompanyName || '';
    }

    public get recipientName() {
        return this.dto.recipientName || '';
    }

    public get returnReason() {
        return this.dto.returnReason || '';
    }

    public get amount() {
        return this.dto.amount || 0;
    }

    public get effectiveDate() {
        return this.dto.effectiveDate ? format(new Date(this.dto.effectiveDate), 'P') : '';
    }

    public get effectiveDateUnix() {
        return this.dto.effectiveDate ? new Date(this.dto.effectiveDate).getTime() : 0;
    }

    public get receivedDate() {
        return this.dto.receivedDate ? format(new Date(this.dto.receivedDate), 'P') : '';
    }

    public get receivedDateUnix() {
        return this.dto.receivedDate ? new Date(this.dto.receivedDate).getTime() : 0;
    }
}
